import React, { useEffect } from "react";

import Privacy from "./components/Footer/Privacy";

import Footer from "./components/Footer/Footer";
import Index from "./components/Index/Index";

import Box from "@mui/material/Box";
import Faq from "./components/Faq/Faq";
import Contact from "./components/Contact/Contact";
import Tech from "./components/About/Tech";
import AllProductsCleansing from "./components/Products/AllProductsCleansing";
import AllProductsLiving from "./components/Products/AllProductsLiving";
import AllProductsPet from "./components/Products/AllProductsPet";
import Home from "./components/Products/Home/Home";
import Product_KO from "./components/Products/Product/Product_KO";
import Product_US from "./components/Products/Product/Product_US";
import Signup from "./components/User/Signup";
import Login from "./components/User/Login";
import Terms from "./components/Footer/Terms";
import Company from "./components/About/Company";
import Media from "./components/Media/Media";
import Forgot from "./components/User/Forgot";

import Why from "./components/About/Why";
import Logout from "./components/User/Logout";
import ChangeInfo from "./components/User/ChangeInfo";
import ChangePassword from "./components/User/ChangePassword";
import OrderHistory from "./components/User/OrderHistory";
import Orders from "./components/User/Cart/Orders";

import Cart_US from "./components/User/Cart/Cart_US";
import Cart_Korea from "./components/User/Cart/Cart_Korea";
import Checkout_Korea from "./components/User/Cart/Checkout_Korea/Checkout";
import Checkout_US from "./components/User/Cart/Checkout_US/Checkout";
import Success from "./components/User/Cart/Success";
import Success_ko from "./components/User/Cart/Success_ko";
import Cancel from "./components/User/Cart/Cancel";

import SimpleNavbar from "./components/Navbar/SimpleNavbar";

import AdminDashboard from "./components/Admin/AdminDashboard";
import AdminProducts_US from "./components/Admin/AdminProducts_US";
import AdminProducts_KO from "./components/Admin/AdminProducts_KO";
import AdminAddProduct from "./components/Admin/AdminAddProduct";
import AdminOrders_KO from "./components/Admin/AdminOrders_KO";
import AdminOrders_US from "./components/Admin/AdminOrders_US";
import AdminReviews from "./components/Admin/AdminReviews";
import AdminFinance from "./components/Admin/AdminFinance";
import AdminAdmins from "./components/Admin/AdminAdmins";
import AdminUsers_KO from "./components/Admin/AdminUsers_KO";
import AdminUsers_US from "./components/Admin/AdminUsers_US";
import AdminAUser from "./components/Admin/AdminAUser";
import AdminSentEmails from "./components/Admin/AdminSentEmails";
import AdminAOrder_US from "./components/Admin/AdminAOrder_US";
import AdminAOrder_KO from "./components/Admin/AdminAOrder_KO";
import Board from "./components/Admin/Board";
import Board_Add from "./components/Admin/Board_Add";
import Board_Modify from "./components/Admin/Board_Modify";
import AdminAOrderGuest_KO from "./components/Admin/AdminAOrderGuest_KO";
import AdminAOrderGuest_US from "./components/Admin/AdminAOrderGuest_US";
//AdminAOrderGuest_KO
import AdminStat from "./components/Admin/AdminStat";
import Page404 from "./components/Page404";

import Dashboard_KO from "./components/User/Dashboard_KO";
import Dashboard_US from "./components/User/Dashboard_US";
import DashboardPersonal from "./components/User/DashboardPersonal";
import DashboardPass from "./components/User/DashboardPass";
import DashboardReview from "./components/User/DashboardReview";
import DashboardSupport from "./components/User/DashboardSupport";
import DashboardAddress from "./components/User/DashboardAddress";
import ModifyAReviewInUserDashboard from "./components/User/ModifyAReviewInUserDashboard";
import DashboardLeaveANewReview from "./components/User/DashboardLeaveANewReview";

import GuestOrder from "./components/User/GuestOrder";

import Return from "./components/Return/Return";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import "./i18n";
import LeaveAReview from "./components/Review/LeaveAReview";
import ModifyAReview from "./components/Review/ModifyAReview";
import AllReviews from "./components/Review/AllReviews";
import B2B from "./components/Contact/B2B/B2B";

import ReactGA from "react-ga";

import { analytics, logEvent, setUserProperties } from "./firebase";

import AdminStat2 from "./components/Admin/AdminStat2";
import AdminStat3 from "./components/Admin/AdminStat3";

import MessageBoard from "./components/Contact/MessageBoard";
import MessageBoardDetail from "./components/Contact/MessageBoardDetail";

import AfterNaverSignup from "./components/User/AfterNaverSignup";
import useGeoLocation from "react-ipgeolocation";
import { useTranslation } from "react-i18next";
import { doc, setDoc, db, serverTimestamp, getDoc } from "./firebase";
import { useAuth } from "./context/AuthContext";

import Navbar_KO from "./components/Navbar/Navbar_KO";
import Navbar_US from "./components/Navbar/Navbar_US";

// custom hook to get the current pathname in React

const App = () => {
  let currentLocation;
  if (window.sessionStorage.getItem("iplookup")) {
    currentLocation = JSON.parse(
      window.sessionStorage.getItem("iplookup")
    ).countryCode;
  } else {
    currentLocation = "KR";
  }
  // currentLocation = "KO";
  console.log(currentLocation);

  document.title = "Heslet LLC";
  const { t, i18n } = useTranslation();
  const { authenticated, currentUser } = useAuth();
  const location = useLocation();

  // asn: "AS7018"
  // asnName: "ATT-INTERNET4"
  // asnOrg: "AT&T Services, Inc."
  // businessName: ""
  // businessWebsite: ""
  // city: "Allen"
  // continent: "North America"
  // country: "United States"
  // countryCode: "US"
  // ipName: "71-146-115-177.lightspeed.rcsntx.sbcglobal.net"
  // ipType: "Residential"
  // isp: "AT&T Corp."
  // lat: "33.10317"
  // lon: "-96.67055"
  // org: "AT&T Corp."
  // query: "71.146.115.177"
  // region: "Texas"
  // status: "success"
  // timezone: "America/Chicago"
  // utcOffset: "-05:00"

  // window.sessionStorage.removeItem("iplookup");
  console.log(
    "localStorage.getItem language",
    localStorage.getItem("language")
  );
  useEffect(() => {
    setting();
    if (localStorage.getItem("language")) {
      i18n.changeLanguage(localStorage.getItem("language"));
    }
    removeCheckoutSession();
  }, []);

  // console.log(
  //   "FinishCheckoutKorea   ",
  //   sessionStorage.getItem("FinishCheckoutKorea")
  // );
  const removeCheckoutSession = () => {
    if (
      location.pathname.includes("checkout_Korea") ||
      location.pathname.includes("success_ko")
    ) {
      // do nothing
    } else {
      sessionStorage.removeItem("FinishCheckoutKorea");
    }
    return location.pathname;
  };

  // window.sessionStorage.removeItem("iplookup");
  const setting = async () => {
    if (!window.sessionStorage.getItem("iplookup")) {
      fetch("https://extreme-ip-lookup.com/json/?key=gaU0ffh8j0GP3mESFth7")
        .then((res) => res.json())
        .then(async (response) => {
          console.log("=====> Country is : ", response);
          window.sessionStorage.setItem("iplookup", JSON.stringify(response));
          if (response.status === "success") {
            let visits = 1;
            const docRef = doc(db, "ipAddressTrack", response.query);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
              visits = +docSnap.data().visits + 1;
            }

            const ref = doc(db, "ipAddressTrack", response.query);
            setDoc(
              ref,
              {
                // timezone: response.timezone,
                region: response.region,
                ipType: response.ipType,
                businessName: response.businessName,
                city: response.city,
                country: response.country,
                countryCode: response.countryCode,
                continent: response.continent,
                created: serverTimestamp(),
                visits: visits,
              },
              { merge: true }
            );
          }
        })
        .catch((data, status) => {
          console.log("Request failed:", data);
        });
    } else {
      let str = JSON.parse(window.sessionStorage.getItem("iplookup"));
      console.log("Location ", str);
    }
    if (currentUser) {
      if (!localStorage.getItem("language")) {
        console.log("====> call users database");
        const docRef = doc(db, "users", currentUser.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          console.log("Document data:", docSnap.data());

          localStorage.setItem("language", docSnap.data().language);
          i18n.changeLanguage(docSnap.data().language);
        }
      }
    }
  };

  // console.log(
  //   "localStorage.getItem language ===>",
  //   localStorage.getItem("language")
  // );
  // console.log("i18n.", i18n.language);

  function RequireAuth({ children }) {
    return authenticated() ? children : <Navigate to="/login" />;
  }

  const outerTheme = createTheme({
    palette: {
      primary: {
        main: "rgb(83, 90, 91)",
      },
      secondary: { main: "#e6d3e4" },
    },
    typography: {
      body1: {
        fontSize: i18n.language === "en" ? 12 : 12,
      },

      // fontFamily: i18n.language === "en" ? "Sofia Pro" : "HallymGothic-Medium",
      fontFamily:
        i18n.language === "en" ? "HallymGothic-Medium" : "HallymGothic-Medium",
    },
  });
  //message-board
  return (
    <ThemeProvider theme={outerTheme}>
      <section id="top"></section>
      <div
        style={{
          maxWidth: "1600px",
          marginLeft: "auto",
          marginRight: "auto",
          backgroundColor: "white",
          overflowX: "hidden",
          // fontFamily:
          //   i18n.language === "en" ? "Sofia Pro" : "HallymGothic-Medium",
          fontFamily:
            i18n.language === "en"
              ? "HallymGothic-Medium"
              : "HallymGothic-Medium",
        }}
      >
        <Routes>
          <Route
            path="/after-naver-signup"
            element={
              <Box>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <AfterNaverSignup />
                <Footer />
              </Box>
            }
          ></Route>
          <Route
            path="/message-board"
            element={
              <Box>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <Box sx={{ mx: { xs: 12, md: 17, sm: 2, xs: 1 } }}>
                  <MessageBoard />
                </Box>
                <Footer />
              </Box>
            }
          />
          <Route
            path="/message-board/:id"
            element={
              <Box>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <Box sx={{ mx: { xs: 12, md: 17, sm: 2, xs: 1 } }}>
                  <MessageBoardDetail />
                </Box>
                <Footer />
              </Box>
            }
          />
          <Route
            path="/b2b"
            element={
              <Box>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <Box sx={{ mx: { xs: 12, md: 17, sm: 2, xs: 1 } }}>
                  <B2B />
                </Box>
                <Footer />
              </Box>
            }
          />
          <Route
            path="/guest-order/:id"
            element={
              <Box>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <GuestOrder />
                <Footer />
              </Box>
            }
          />
          <Route
            path="/guest-order"
            element={
              <Box>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <GuestOrder />
                <Footer />
              </Box>
            }
          />
          <Route
            path="/success_ko"
            element={
              <Box>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <Success_ko />
                <Footer />
              </Box>
            }
          />
          <Route
            path="/success"
            element={
              <Box>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <Success />
                <Footer />
              </Box>
            }
          />
          <Route
            path="/return"
            element={
              <Box>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <Return />
                <Footer />
              </Box>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}

                <AdminDashboard />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/board"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Board />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/board_add"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Board_Add />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/board_modify/:id"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Board_Modify />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/finance"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminFinance />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/users_ko"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminUsers_KO />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/users_us"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminUsers_US />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/user/:id"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminAUser />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/reviews"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminReviews />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/leave-a-review"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <LeaveAReview />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/edit-a-review"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <ModifyAReview />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/all-reviews"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AllReviews />
                <Footer />
              </>
            }
          />
          <Route
            path="/admin/orders_ko"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminOrders_KO />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/orders_ko/:newPage"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminOrders_KO />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/orders_us"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminOrders_US />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/orders_us/:newPage"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminOrders_US />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/admins"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminAdmins />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/products_ko"
            element={
              <RequireAuth>
                <Navbar_KO index={false} />
                <AdminProducts_KO />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/products_us"
            element={
              <RequireAuth>
                <Navbar_US index={false} />
                <AdminProducts_US />
                <Footer />
              </RequireAuth>
            }
          />
          {/* <Route
            path="/admin/order/:id"
            element={
              <RequireAuth>
                <Navbar index={false} />
                <AdminAOrder />
                <Footer />
              </RequireAuth>
            }
          /> */}
          <Route
            path="/admin/order_us/:id"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminAOrder_US />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/order_guest_ko/:id"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminAOrderGuest_KO />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/order_guest_us/:id"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminAOrderGuest_US />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/order_ko/:id"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminAOrder_KO />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/add-products"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminAddProduct />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/stat"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminStat />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/stat2"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminStat2 />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/stat3"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminStat3 />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/sent-emails"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <AdminSentEmails />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                {currentLocation === "KR" ? <Dashboard_KO /> : <Dashboard_US />}
                <Footer />
              </RequireAuth>
            }
          />{" "}
          <Route
            path="/dashboard-edit-review"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <ModifyAReviewInUserDashboard />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Index currentLocation={currentLocation} />
                <Footer />
              </>
            }
          />
          <Route
            path="/logout"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Logout />
                <Footer />
              </>
            }
          />
          <Route
            path="/checkout_US"
            element={
              <Box
                sx={{
                  height: "100vh",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "white",
                }}
              >
                <SimpleNavbar />
                <Checkout_US />
              </Box>
            }
          />
          <Route
            path="/checkout_Korea"
            element={
              <Box
                sx={{
                  height: "100vh",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "white",
                }}
              >
                <SimpleNavbar />
                <Checkout_Korea />
              </Box>
            }
          />
          <Route
            path="/cancel"
            element={
              <Box>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <Cancel />
                <Footer />
              </Box>
            }
          />
          <Route
            path="/change-userinfo"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <ChangeInfo />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/dashboard-password"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <DashboardPass />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/dashboard-address"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <DashboardAddress />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/dashboard-review"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <DashboardReview />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/dashboard-leave-a-new-review"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <DashboardLeaveANewReview />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/dashboard-support"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <DashboardSupport />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/orders"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <Orders />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/change-password"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <ChangePassword />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/order-history"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}
                <OrderHistory />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/products-cleansing"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                {/* <Box sx={{ mx: { xs: 12, md: 17 } }}> */}
                <AllProductsCleansing />
                {/* </Box> */}
                <Footer />
              </>
            }
          />
          <Route
            path="/products-living"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                {/* <Box sx={{ mx: { xs: 12, md: 17 } }}> */}
                <AllProductsLiving />
                {/* </Box> */}
                <Footer />
              </>
            }
          />
          <Route
            path="/products-pet"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                {/* <Box sx={{ mx: { xs: 12, md: 17 } }}> */}
                <AllProductsPet />
                {/* </Box> */}
                <Footer />
              </>
            }
          />
          <Route
            path="/forgot"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Box sx={{ mx: { xs: 12, md: 17 } }}>
                  <Forgot />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/why"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Why />
                <Footer />
              </>
            }
          />
          <Route
            path="/home"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Box sx={{ mx: { xs: 12, md: 17 } }}>
                  <Home />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/cart"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={true} />
                ) : (
                  <Navbar_US index={true} />
                )}

                {currentLocation === "KR" ? <Cart_Korea /> : <Cart_US />}
                <Footer />
              </>
            }
          />
          <Route
            path="/product/:productName"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                {currentLocation === "KR" ? <Product_KO /> : <Product_US />}
                <Footer />
              </>
            }
          />
          <Route
            path="/login"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Login />
                <Footer />
              </>
            }
          />
          <Route
            path="/dashboard-personal"
            element={
              <RequireAuth>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <DashboardPersonal />
                <Footer />
              </RequireAuth>
            }
          />
          <Route
            path="/media"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Media />
                <Footer />
              </>
            }
          />
          <Route
            path="/terms-and-condition"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Box sx={{ mx: { xs: 12, md: 17 } }}>
                  <Terms />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/signup"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Signup />
                <Footer />
              </>
            }
          />
          <Route
            path="/privacy"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Box sx={{ mx: { xs: 12, md: 17, sm: 2, xs: 1 } }}>
                  <Privacy />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/faq"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Box sx={{ mx: { xs: 12, md: 17, sm: 2, xs: 1 } }}>
                  <Faq />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/faq/:id"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Box sx={{ mx: { xs: 12, md: 17, sm: 2, xs: 1 } }}>
                  <Faq />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/contact"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Box sx={{ mx: { xs: 12, md: 17, sm: 2, xs: 1 } }}>
                  <Contact />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/contact/:id"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Box sx={{ mx: { xs: 12, md: 17, sm: 2, xs: 1 } }}>
                  <Contact />
                </Box>
                <Footer />
              </>
            }
          />
          <Route
            path="/company"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Company />
                <Footer />
              </>
            }
          />
          <Route
            path="/technology"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Tech />
                <Footer />
              </>
            }
          />
          <Route
            path="*"
            element={
              <>
                {currentLocation === "KR" ? (
                  <Navbar_KO index={false} />
                ) : (
                  <Navbar_US index={false} />
                )}
                <Page404 />
                <Footer />
              </>
            }
          />
        </Routes>
      </div>
    </ThemeProvider>
  );
};

export default App;
